import { brand, gray_2 } from '../../../styles/rn';
import { CustomStyleSheet } from '../../../utils/rn/tools';
export default CustomStyleSheet({
  'food-buyer-order': {
    width: '100%'
  },
  'food-buyer-order-shop': {
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(0, 0, 0, 0.06)',
    display: 'flex',
    backgroundColor: '#fff',
    lineHeight: 16,
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'nowrap'
  },
  'food-buyer-order-shop__name': {
    fontSize: 14,
    // color: 'rgba(0, 0, 0, 0.87)',
    flexGrow: 1,
    flexShrink: 1,
    marginRight: 12,
    alignSelf: 'center',
    color: gray_2
  },
  'food-buyer-order-shop__type': {
    fontSize: 14,
    lineHeight: 16,
    color: brand,
    flexShrink: 0,
    flexGrow: 1,
    textAlign: 'right'
  },
  'food-buyer-order-buttons': {
    paddingVertical: 6,
    paddingHorizontal: 0,
    textAlign: 'right',
    marginBottom: 8,
    backgroundColor: '#fff',
    borderTopWidth: 1,
    borderTopColor: 'rgba(0, 0, 0, 0.06)',
    paddingRight: 16,
    alignItems: 'flex-end'
  },
  'food-buyer-order-button': {
    minWidth: undefined,
    margin: 0,
    paddingVertical: 10,
    paddingHorizontal: 16,
    display: 'flex'
  }
});